import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './create-report.css';
import Select from 'react-select';
import { PiPlus, PiInfoDuotone } from 'react-icons/pi';
import { FaTrashAlt } from 'react-icons/fa';
import axios from '../../axios';
import apiError from '../../error';
import { BiGridVertical } from "react-icons/bi";
import { toast } from 'react-toastify';
import { hypenateToNormal } from '../../function';
const MAX_CRITERIA_ROWS = 5;
const SELECT_STYLES = {
    control: (base, state) => ({
        ...base,
        fontSize: '13px',
        height: '34px',
        minHeight: '34px',
        borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
        color: '#000',
        '&:hover': {
            borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        height: '34px',
        padding: '0 8px',
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: '34px',
    }),
    placeholder: (base) => ({
        ...base,
        fontSize: '13px',
        color: '#000',
    }),
    singleValue: (base) => ({
        ...base,
        fontSize: '12px',
    }),
    option: (base) => ({
        ...base,
        fontSize: '12px',
    }),
    input: (base) => ({
        ...base,
        fontSize: '12px',
    }),
};

const MULTI_SELECT_STYLES = {
    ...SELECT_STYLES,
    control: (base, state) => ({
        ...base,
        fontSize: '13px',
        minHeight: '34px',
        height: 'auto',
        borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
        boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
        color: '#000',
        '&:hover': {
            borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        minHeight: '34px',
        height: 'auto',
        padding: '2px 8px',
        flexWrap: 'wrap',
    }),
    indicatorsContainer: (base) => ({
        ...base,
        minHeight: '34px',
        alignItems: 'flex-start',
    }),
    multiValue: (base) => ({
        ...base,
        fontSize: '12px',
    }),
};


const OPERATOR_LABELS = {
    'in': 'Equal',
    'between': 'Between',
    'lt': 'Less Than (<)',
    'gt': 'Greater Than (>)',
    'gte': 'Greater Than or Equal (≥)',
    'lte': 'Less Than or Equal (≤)',
    'eq': 'Equal To (=)',
};

const formatAttributeLabel = (attr) =>
    attr.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());



const buildSortOptions = (sortCondition, sortingOrder) => {
    const options = [];
    sortCondition.forEach((cond) => {
        sortingOrder.forEach((order) => {
            options.push({
                value: `${cond}:${order}`,
                label: `${formatAttributeLabel(cond)} (${order.toUpperCase()})`,
            });
        });
    });
    return options;
};

const STATUS_OPTIONS = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
];

/** Criteria number fields are whole numbers only (no 9.5, no scientific notation). */
const suppressFloatAndScientificInNumber = (e) => {
    if (e.key === '.' || e.key === ',' || e.key === 'e' || e.key === 'E' || e.key === '+') {
        e.preventDefault();
    }
};

const toIntegerString = (raw) => {
    if (raw == null) return '';
    const s = String(raw);
    if (s === '') return '';
    const intPart = s.split('.')[0].split(/[eE]/)[0];
    if (intPart === '' || intPart === '-') return intPart;
    const m = intPart.match(/^-?\d*$/);
    if (m) return m[0];
    return (intPart.replace(/[^\d-]/g, '').match(/^-?\d*/) || [''])[0];
};

class CreateReportModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportName: '',
            module: '',
            moduleType: {
                user: true,
                campaign: false,
            },
            criteriaRows: [this.getEmptyCriteriaRow()],
            departmentOptions: [],
            designationOptions: [],
            locationOptions: [],
            attackVectorOptions: [],
            campaignOptions: [],
            statusOptions: [
                { value: 'Completed', label: 'Completed' },
                { value: 'In Progress', label: 'In Progress' }
            ],
            rules: [],
            sortCondition: [],
            sortingOrder: [],
            sortByField: '',
            sortByOrder: '',
            criteriaType: 'column',
            columnFields: [],
            draggingColumnId: null,
            column: ["name"],
            defaultRules: [],
            modules: []
        };

    }
    componentDidMount() {
        this.fetchModules();
    }

    handleCriteria = (type) => {
        this.setState({ criteriaType: type });
    }

    handleColumnDragStart = (columnId) => {
        this.setState({ draggingColumnId: columnId });
    };

    handleColumnDragOver = (event) => {
        event.preventDefault();
    };

    getColumnsWithNameFirst = (columnFields) => {
        const selected = columnFields
            .filter((col) => col.checked)
            .map((col) => col.id);
        const withoutName = selected.filter((id) => id !== 'name');
        return ['name', ...withoutName];
    };

    handleColumnDrop = (targetColumnId) => {
        this.setState((prevState) => {
            const { columnFields, draggingColumnId } = prevState;
            if (!draggingColumnId || draggingColumnId === targetColumnId) return { draggingColumnId: null };

            const items = [...columnFields];
            const fromIndex = items.findIndex((c) => c.id === draggingColumnId);
            const toIndex = items.findIndex((c) => c.id === targetColumnId);
            if (fromIndex === -1 || toIndex === -1) return { draggingColumnId: null };

            const [moved] = items.splice(fromIndex, 1);
            items.splice(toIndex, 0, moved);

            // Rebuild column array with "name" always first
            const column = this.getColumnsWithNameFirst(items);

            return { columnFields: items, column, draggingColumnId: null };
        });
    };

    handleColumnCheckToggle = (columnId) => {
        this.setState((prevState) => {
            const columnFields = prevState.columnFields.map((col) =>
                col.id === columnId ? { ...col, checked: !col.checked } : col
            );

            // Build the "column" array from checked items with "name" always first
            const column = this.getColumnsWithNameFirst(columnFields);

            return { columnFields, column };
        });
    };

    componentDidUpdate(prevProps) {
        const { show, initialData } = this.props;
        const justOpened = show && !prevProps.show;
        const initialDataChanged = initialData && initialData !== prevProps.initialData;
        if (show && initialData && (justOpened || initialDataChanged)) {
            const d = initialData;
            this.setState({
                reportName: d.name || '',
                module: d.module || '',
                moduleType: this.getModuleType(d.module || ''),
                sortByField: d.sortCondition || '',
                sortByOrder: d.sortingOrder || '',
            }, () => {
                if (d.module) {
                    this.fetchAllAttributesAndRules(d.module, d);
                } else {
                    this.setState({ criteriaRows: [this.getEmptyCriteriaRow()] });
                }
            });
        }
    }

    getEmptyCriteriaRow = () => ({
        attribute: '',
        operator: '',
        selectedOption: null,
        value: '',
        valueTo: '',
        joiner: '',
    });

    getModuleType = (moduleName) => ({
        user: moduleName === 'user',
        campaign: moduleName === 'campaign',
    });

    handleChange = (field, value) => {
        const updates = { [field]: value };
        if (field === 'module') {
            updates.moduleType = this.getModuleType(value);
            this.fetchAllAttributesAndRules(value);
        }
        this.setState(updates);
    };

    formatLabel = (key) => {
        return key
            .replace(/-/g, " ")                 // kebab-case → space
            .replace(/([A-Z])/g, " $1")         // camelCase → space
            .replace(/\b\w/g, c => c.toUpperCase()) // capitalize words
            .trim();
    };

    generateColumnFields = (obj, preSelectedColumns = []) => {
        const hasExplicitSelection = Array.isArray(preSelectedColumns) && preSelectedColumns.length > 0;
        const selectedSet = new Set(preSelectedColumns);
        const exclude = new Set(['name', 'date-range']);
        const allKeys = Object.keys(obj).filter((key) => !exclude.has(key));

        let orderedKeys;
        if (hasExplicitSelection) {
            const seen = new Set();
            orderedKeys = [];
            for (const key of preSelectedColumns) {
                if (exclude.has(key) || seen.has(key)) continue;
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    orderedKeys.push(key);
                    seen.add(key);
                }
            }
            for (const key of allKeys) {
                if (!seen.has(key)) {
                    orderedKeys.push(key);
                    seen.add(key);
                }
            }
        } else {
            orderedKeys = allKeys;
        }

        return orderedKeys.map((key) => ({
            id: key,
            label: this.formatLabel(key),
            checked: hasExplicitSelection ? selectedSet.has(key) : true,
        }));
    };

    fetchAllAttributesAndRules = (module, initialDataToApply) => {
        const isEditMode = initialDataToApply && typeof initialDataToApply === 'object';
        axios.get('api/custom-reports/attributes-and-rules', {
            params: {
                module: module,
            }
        })
            .then(res => {
                const rules = res?.data?.attributesAndRules?.rule || [];
                const filteredRules = rules.filter(rule => rule?.type !== 'default');
                const sortCondition = res?.data?.attributesAndRules?.sortCondition || [];
                const sortingOrder = res?.data?.attributesAndRules?.sortingOrder || [];

                const attributeMap = res?.data?.attributesAndRules?.attributeMap || {};
                const preSelectedColumns = Array.isArray(initialDataToApply?.columns)
                    ? initialDataToApply.columns
                    : Array.isArray(initialDataToApply?.column)
                        ? initialDataToApply.column
                        : [];
                const columnFields = this.generateColumnFields(attributeMap, preSelectedColumns);
                const column = this.getColumnsWithNameFirst(columnFields);

                this.setState((prevState) => ({
                    ...prevState,
                    rules: filteredRules,
                    sortCondition,
                    sortingOrder,
                    defaultRules: rules
                        .filter(rule => rule?.type === 'default')
                        .map(rule => ({
                            ...rule,
                            operator: "in",
                            arrayValues: []
                        })),
                    columnFields,
                    column,
                }));

                const ruleList = isEditMode && Array.isArray(initialDataToApply.rule) ? initialDataToApply.rule : [];
                if (ruleList.length > 0) {
                    const needDept = ruleList.some((r) => r.attribute === 'department');
                    const needDesig = ruleList.some((r) => r.attribute === 'designation');
                    const needLoc = ruleList.some((r) => r.attribute === 'location');
                    const needAttackVector = ruleList.some((r) => r.attribute === 'attack-vector');
                    const needCampaign = ruleList.some((r) => r.attribute === 'campaign');
                    const promises = [
                        needDept ? axios.get('/api/departments') : Promise.resolve(null),
                        needDesig ? axios.get('/api/designations') : Promise.resolve(null),
                        needLoc ? axios.get('/api/locations') : Promise.resolve(null),
                        needAttackVector ? axios.get('/api/attacktypes') : Promise.resolve(null),
                        needCampaign ? axios.get('/api/campaigns/list') : Promise.resolve(null),
                    ];

                    Promise.all(promises).then(([deptRes, desigRes, locRes, attackVectorRes, campaignRes]) => {
                        const optionsMap = {};
                        if (deptRes?.data?.departments) {
                            optionsMap.departmentOptions = deptRes.data.departments.map((d) => ({ value: d.id, label: d.name }));
                        }
                        if (desigRes?.data?.designations) {
                            optionsMap.designationOptions = desigRes.data.designations.map((d) => ({ value: d.id, label: d.name }));
                        }
                        if (locRes?.data?.locations) {
                            optionsMap.locationOptions = locRes.data.locations.map((l) => ({ value: l.id, label: l.name }));
                        }
                        const attackTypesList = attackVectorRes?.data?.attackTypes || attackVectorRes?.data?.attackVectors;
                        if (Array.isArray(attackTypesList) && attackTypesList.length) {
                            optionsMap.attackVectorOptions = attackTypesList.map((a) => ({
                                value: a.id,
                                label: a.name,
                            }));
                        }
                        if (campaignRes?.data?.campaigns) {
                            optionsMap.campaignOptions = campaignRes.data.campaigns.map((c) => ({ value: c.id, label: c.name }));
                        }
                        const criteriaRows = ruleList.map((r, i) => {
                            const ruleDef = filteredRules.find((rf) => rf.attribute === r.attribute);
                            return this.mapRuleToCriteriaRow(r, i, ruleDef, optionsMap);
                        });
                        this.setState((prevState) => ({
                            ...prevState,
                            departmentOptions: optionsMap.departmentOptions || prevState.departmentOptions,
                            designationOptions: optionsMap.designationOptions || prevState.designationOptions,
                            locationOptions: optionsMap.locationOptions || prevState.locationOptions,
                            attackVectorOptions: optionsMap.attackVectorOptions || prevState.attackVectorOptions,
                            campaignOptions: optionsMap.campaignOptions || prevState.campaignOptions,
                            criteriaRows: criteriaRows.length ? criteriaRows : [this.getEmptyCriteriaRow()],
                        }));
                    });
                } else if (isEditMode) {
                    this.setState({ criteriaRows: [this.getEmptyCriteriaRow()] });
                }
            })
            .catch(err => apiError(err));
    }

    fetchModules = async () => {
        try {
            const response = await axios.get('/api/custom-reports/modules');
            this.setState({ modules: response.data.modules });
        } catch (error) {
            apiError(error);
        }
    }
    buildPayload = () => {
        const { reportName, module, criteriaRows, sortByField, sortByOrder, column, defaultRules } = this.state;

        const rule = criteriaRows.map((row) => {
            const ruleObj = this.getRuleForAttribute(row.attribute);
            const isEqualOperator = row.operator === 'eq' || row.operator === 'in';
            const entry = {
                attribute: row.attribute,
                arrayValues: null,
                operator: row.operator || null,
                minRange: null,
                maxRange: null,
            };

            if (ruleObj && Array.isArray(ruleObj.arrayValues) && ['department', 'designation', 'location', 'attack-vector', 'campaign'].includes(row.attribute)) {
                entry.arrayValues = row.selectedOption
                    ? (Array.isArray(row.selectedOption) ? row.selectedOption.map((o) => o.value) : [row.selectedOption.value])
                    : [];
            }
            else if (row.attribute === 'status') {
                entry.arrayValues = row.selectedOption ? [row.selectedOption.value] : [];
            }
            else if (ruleObj && ruleObj.rangeType === 'number') {
                if (isEqualOperator) {
                    entry.arrayValues = row.value !== '' ? [Number(row.value)] : [];
                } else if (row.operator === 'between') {
                    entry.minRange = row.value !== '' ? Number(row.value) : null;
                    entry.maxRange = row.valueTo !== '' ? Number(row.valueTo) : null;
                } else if (row.operator === 'lt' || row.operator === 'lte') {
                    entry.maxRange = row.value !== '' ? Number(row.value) : null;
                } else {
                    entry.minRange = row.value !== '' ? Number(row.value) : null;
                }
            } else if (ruleObj && ruleObj.rangeType === 'date') {
                if (isEqualOperator) {
                    entry.arrayValues = row.value ? [row.value] : [];
                } else if (row.operator === 'between') {
                    entry.minRange = row.value || null;
                    entry.maxRange = row.valueTo || null;
                } else if (row.operator === 'lt' || row.operator === 'lte') {
                    entry.maxRange = row.value || null;
                } else {
                    entry.minRange = row.value || null;
                }
            } else if (ruleObj && ruleObj.type === 'default') {
                entry.arrayValues = row.value ? [row.value] : [];
            }

            return entry;
        });

        const columnsToSend = (column && column.length) ? column : ['name'];

        const finalRule = [
            // ...(defaultRules || []),
            ...rule,
        ];

        return {
            module,
            name: reportName,
            rule: finalRule,
            sortCondition: sortByField || null,
            sortingOrder: sortByOrder || null,
            columns: columnsToSend,
        };
    };

    handleCreateReport = () => {
        const { reportName, module, sortByField, sortByOrder } = this.state;
        if (!reportName || !module) return;
        if (!sortByField || !sortByOrder) {
            toast.error('Kindly fill all the required fields');
            return;
        }
        const rangeErr = this.getFirstNumberBetweenRangeError();
        if (rangeErr) {
            toast.error(rangeErr);
            return;
        }
        if (!this.hasValidFilters()) return;

        const payload = this.buildPayload();
        axios.post('/api/custom-reports', payload)
            .then((res) => {
                const data = res.data || {};
                const createdId =
                    data.id ??
                    data.customReport?.id ??
                    data.reportId ??
                    data.data?.id;
                this.setState({
                    reportName: '',
                    module: '',
                    criteriaRows: [this.getEmptyCriteriaRow()],
                    sortByField: '',
                    sortByOrder: '',
                    rules: [],
                    sortCondition: [],
                    sortingOrder: [],
                });
                toast.success(data.message);
                this.props.onHide && this.props.onHide();
                this.props.onSubmit && this.props.onSubmit(data);
                if (createdId != null && createdId !== '' && this.props.history) {
                    this.props.history.push(`/reports/report/${createdId}`);
                }
            })
            .catch((err) => apiError(err));
    };

    handleUpdateReport = () => {
        const { reportName, module, sortByField, sortByOrder } = this.state;
        if (!reportName || !module) return;
        if (!sortByField || !sortByOrder) {
            toast.error('Kindly fill all the required fields');
            return;
        }
        const rangeErr = this.getFirstNumberBetweenRangeError();
        if (rangeErr) {
            toast.error(rangeErr);
            return;
        }
        if (!this.hasValidFilters()) return;

        const payload = this.buildPayload();
        this.updateReport(payload);
    };

    updateReport = (payload) => {
        const { id } = this.props.initialData;
        axios.patch(`/api/custom-reports/${id}`, payload)
            .then((res) => {
                this.setState({
                    reportName: '',
                    module: '',
                    criteriaRows: [this.getEmptyCriteriaRow()],
                    sortByField: '',
                    sortByOrder: '',
                });
                this.props.onHide && this.props.onHide();
                toast.success(res.data.message);
                this.props.onSubmit && this.props.onSubmit(res.data);
            })
            .catch((err) => apiError(err));
    }

    handleClose = () => {
        this.setState({
            reportName: '',
            module: '',
            criteriaRows: [this.getEmptyCriteriaRow()],
            sortByField: '',
            sortByOrder: '',
            rules: [],
            sortCondition: [],
            sortingOrder: [],
        });
        this.props.onHide && this.props.onHide();
    };

    handleCriteriaChange = (index, field, value) => {
        this.setState((prevState) => {
            const criteriaRows = [...prevState.criteriaRows];
            const updated = { ...criteriaRows[index], [field]: value < 0 ? 0 : value };
            if (field === 'operator' && value !== 'between') {
                updated.valueTo = '';
            }
            criteriaRows[index] = updated;
            return { criteriaRows };
        });
    };

    parseCriteriaNumber = (s) => {
        if (s === '' || s == null) return null;
        const n = Number(s);
        return Number.isFinite(n) ? n : null;
    };

    getFirstNumberBetweenRangeError = () => {
        const { criteriaRows } = this.state;
        for (let i = 0; i < criteriaRows.length; i++) {
            const c = criteriaRows[i];
            if (!c.attribute || !c.operator || c.operator !== 'between') continue;
            const rule = this.getRuleForAttribute(c.attribute);
            if (!rule || rule.rangeType !== 'number') continue;
            if (c.value === '' || c.valueTo === '') continue;

            const minN = this.parseCriteriaNumber(c.value);
            const maxN = this.parseCriteriaNumber(c.valueTo);
            if (minN == null || maxN == null) {
                return 'Enter valid numbers for min and max range.';
            }
            if (maxN <= minN) {
                return 'Max value must be greater than min value.';
            }
            if (rule.minRange != null) {
                if (minN < rule.minRange || maxN < rule.minRange) {
                    return `Values must be at least ${rule.minRange}.`;
                }
            }
            if (rule.maxRange != null) {
                if (minN > rule.maxRange || maxN > rule.maxRange) {
                    return `Values must be at most ${rule.maxRange}.`;
                }
            }
        }
        return null;
    };

    mapRuleToCriteriaRow = (r, index, ruleDef, optionsMap) => {
        const row = {
            ...this.getEmptyCriteriaRow(),
            attribute: r.attribute,
            operator: r.operator || '',
            joiner: index > 0 ? 'AND' : '',
        };
        if (!ruleDef) return row;
        if (['department', 'designation', 'location', 'attack-vector', 'campaign', 'status'].includes(r.attribute)) {
            const key = r.attribute === 'department' ? 'departmentOptions' : r.attribute === 'designation' ? 'designationOptions' : r.attribute === 'location' ? 'locationOptions' : r.attribute === 'attack-vector' ? 'attackVectorOptions' : r.attribute === 'campaign' ? 'campaignOptions' : 'statusOptions';
            const opts = optionsMap[key] || this.state[key] || [];
            const arr = (r.arrayValues || []);
            row.selectedOption = arr.map((id) => {
                const opt = opts.find((o) => String(o.value) === String(id));
                return opt ? { value: opt.value, label: opt.label } : { value: id, label: String(id) };
            });
        } else if (ruleDef.rangeType === 'number' || ruleDef.rangeType === 'date') {
            if ((r.operator === 'eq' || r.operator === 'in') && Array.isArray(r.arrayValues) && r.arrayValues.length) {
                row.value = String(r.arrayValues[0]);
                row.valueTo = '';
            } else if (r.operator === 'between') {
                row.value = r.minRange != null ? String(r.minRange) : '';
                row.valueTo = r.maxRange != null ? String(r.maxRange) : '';
            } else if (r.operator === 'lt' || r.operator === 'lte') {
                row.value = r.maxRange != null ? String(r.maxRange) : '';
                row.valueTo = '';
            } else {
                row.value = r.minRange != null ? String(r.minRange) : '';
                row.valueTo = '';
            }
        } else if (ruleDef.type === 'default' && r.arrayValues && r.arrayValues.length) {
            row.value = String(r.arrayValues[0]);
        }
        return row;
    };



    getDepartmentOptions = () => {
        axios.get('/api/departments')
            .then(res => {
                let departmentOptions = res.data.departments.map(department => ({
                    value: department.id,
                    label: department.name
                }));
                this.setState((prevState) => ({
                    ...prevState,
                    departmentOptions: departmentOptions,
                }));
            })
            .catch(err => {
                console.log(err);
                return [];
            });
    }

    getDesignationOptions = () => {

        axios.get('/api/designations')
            .then(res => {
                let designationOptions = res.data.designations.map(designation => ({
                    value: designation.id,
                    label: designation.name
                }));
                this.setState((prevState) => ({
                    ...prevState,
                    designationOptions: designationOptions,
                }));
            })
            .catch(err => {
                console.log(err);
                return [];
            });
    }
    getLocationOptions = () => {
        axios.get('/api/locations')
            .then(res => {
                let locationOptions = res.data.locations.map(location => ({
                    value: location.id,
                    label: location.name
                }));
                this.setState((prevState) => ({
                    ...prevState,
                    locationOptions: locationOptions,
                }));
            })
            .catch(err => {
                console.log(err);
                return [];
            });
    }
    getCampaignOptions = () => {
        axios.get('/api/campaigns/list')
            .then(res => {
                let campaignOptions = res.data.campaigns.map(campaign => ({
                    value: campaign.id,
                    label: campaign.name
                }));
                this.setState((prevState) => ({
                    ...prevState,
                    campaignOptions: campaignOptions,
                }));
            })
            .catch(err => {
                console.log(err);
                return [];
            });
    }
    getattackVectorOptions = () => {
        axios.get('/api/attacktypes')
            .then(res => {
                let attackVectorOptions = res.data.attackTypes.map(attackVector => ({
                    value: attackVector.id,
                    label: attackVector.name
                }));
                this.setState((prevState) => ({
                    ...prevState,
                    attackVectorOptions: attackVectorOptions,
                }));
            })
            .catch(err => {
                console.log(err);
                return [];
            });
    }
    getRuleForAttribute = (attributeName) => {
        return this.state.rules.find((r) => r.attribute === attributeName) || null;
    }
    handleAttributeChange = (index, value) => {
        this.setState((prevState) => {
            const criteriaRows = [...prevState.criteriaRows];
            criteriaRows[index] = {
                ...criteriaRows[index],
                attribute: value,
                operator: '',
                selectedOption: null,
                value: '',
                valueTo: '',
            };
            return { criteriaRows };
        });

        if (value === 'department') this.getDepartmentOptions();
        if (value === 'designation') this.getDesignationOptions();
        if (value === 'location') this.getLocationOptions();
        if (value === 'attack-vector') this.getattackVectorOptions();
        if (value === 'campaign') this.getCampaignOptions();
    };

    handleAddCriteria = () => {
        this.setState((prevState) => {
            if (prevState.criteriaRows.length >= MAX_CRITERIA_ROWS) return null;
            return {
                criteriaRows: [
                    ...prevState.criteriaRows,
                    { ...this.getEmptyCriteriaRow(), joiner: 'AND' },
                ],
            };
        });
    };

    handleRemoveCriteria = (index) => {
        if (index === 0) return;
        this.setState((prevState) => ({
            criteriaRows: prevState.criteriaRows.filter((_, rowIndex) => rowIndex !== index),
        }));
    };

    getSelectOptionsForAttribute = (attributeName) => {
        switch (attributeName) {
            case 'department': return this.state.departmentOptions;
            case 'designation': return this.state.designationOptions;
            case 'location': return this.state.locationOptions;
            case 'attack-vector': return this.state.attackVectorOptions;
            case 'campaign': return this.state.campaignOptions;
            case 'status': return this.state.statusOptions;

            default: return [];
        }
    };

    renderValueInput = (criteria, index, rule) => {
        if (!criteria.attribute || !rule) {
            return (
                <Form.Control as="select" disabled>
                    <option value="">Select an option</option>
                </Form.Control>
            );
        }

        if (rule.type === 'default') {
            return (
                <Form.Control
                    type="text"
                    placeholder="Enter value"
                    value={criteria.value || ''}
                    onChange={(e) => this.handleCriteriaChange(index, 'value', e.target.value)}
                />
            );
        }

        if (rule.attribute === 'status') {
            return (
                <Select
                    options={STATUS_OPTIONS}
                    value={criteria.selectedOption}
                    onChange={(opt) => this.handleCriteriaChange(index, 'selectedOption', opt)}
                    placeholder="Select status"
                    styles={SELECT_STYLES}
                    isClearable
                />
            );
        }
        if (Array.isArray(rule.arrayValues) && ['department', 'designation', 'location', 'attack-vector', 'campaign'].includes(rule.attribute)) {
            return (
                <Select
                    options={this.getSelectOptionsForAttribute(rule.attribute)}
                    value={criteria.selectedOption}
                    onChange={(opt) => this.handleCriteriaChange(index, 'selectedOption', opt)}
                    placeholder="Select an option"
                    styles={MULTI_SELECT_STYLES}
                    isMulti={rule.attribute !== 'status'}
                />
            );
        }

        if (rule.rangeType === 'number') {

            const handleNumberChange = (index, field, rawValue, rule) => {
                let value = toIntegerString(rawValue);

                if (value === '' || value === '-') {
                    this.handleCriteriaChange(index, field, value);
                    return;
                }

                let num = Number(value);

                if (!Number.isFinite(num)) return;

                // Apply min constraint
                if (rule.minRange != null && num < rule.minRange) {
                    num = rule.minRange;
                }

                // Apply max constraint
                if (rule.maxRange != null && num > rule.maxRange) {
                    num = rule.maxRange;
                }

                this.handleCriteriaChange(index, field, String(num));
            };

            if (criteria.operator === 'between') {
                return (
                    <div className="d-flex gap-2">
                        <Form.Control
                            type="number"
                            step="1"
                            inputMode="numeric"
                            placeholder={rule.minRange != null ? `Min (${rule.minRange})` : 'Min'}
                            value={criteria.value}
                            onKeyDown={suppressFloatAndScientificInNumber}
                            onChange={(e) =>
                                handleNumberChange(index, 'value', e.target.value, rule)
                            }
                        />
                        <Form.Control
                            type="number"
                            step="1"
                            inputMode="numeric"
                            placeholder={rule.maxRange != null ? `Max (${rule.maxRange})` : 'Max'}
                            value={criteria.valueTo}
                            onKeyDown={suppressFloatAndScientificInNumber}
                            onChange={(e) =>
                                handleNumberChange(index, 'valueTo', e.target.value, rule)
                            }
                        />
                    </div>
                );
            }
        }

        if (rule.rangeType === 'date') {
            if (criteria.operator === 'between') {
                return (
                    <div className="d-flex gap-2">
                        <Form.Control
                            type="date"
                            value={criteria.value}
                            onChange={(e) => this.handleCriteriaChange(index, 'value', e.target.value)}
                            style={{ width: '50%' }}
                        />
                        <Form.Control
                            type="date"
                            value={criteria.valueTo}
                            onChange={(e) => this.handleCriteriaChange(index, 'valueTo', e.target.value)}
                            style={{ width: '50%' }}
                        />
                    </div>
                );
            }
            return (
                <Form.Control
                    type="date"
                    value={criteria.value}
                    onChange={(e) => this.handleCriteriaChange(index, 'value', e.target.value)}
                />
            );
        }

        return (
            <Form.Control
                type="text"
                placeholder="Enter value"
                value={criteria.value || ''}
                onChange={(e) => this.handleCriteriaChange(index, 'value', e.target.value)}
            />
        );
    };

    isCriteriaComplete = (criteria) => {
        if (!criteria.attribute || !criteria.operator) return false;
        const rule = this.getRuleForAttribute(criteria.attribute);
        if (!rule) return false;
        if (rule.type === 'default') return !!criteria.value;
        if (rule.rangeType === 'number' || rule.rangeType === 'date') {
            if (criteria.operator === 'between') {
                if (criteria.value === '' || criteria.valueTo === '') return false;
                if (rule.rangeType === 'number') {
                    const minN = Number(criteria.value);
                    const maxN = Number(criteria.valueTo);
                    if (!Number.isFinite(minN) || !Number.isFinite(maxN)) return false;
                }
                return true;
            }
            return criteria.value !== '';
        }
        if (rule.arrayValues) return !!criteria.selectedOption;
        return !!criteria.value;
    };

    hasValidFilters = () => {
        const { criteriaRows } = this.state;
        const hasAtLeastOneCompleteCriteria = criteriaRows.some((criteria) => this.isCriteriaComplete(criteria));
        const hasIncompleteCriteria = criteriaRows.some((criteria) => !this.isCriteriaComplete(criteria));
        return hasAtLeastOneCompleteCriteria && !hasIncompleteCriteria;
    };

    render() {
        const { show, initialData } = this.props;
        const editMode = !!initialData;
        const { reportName, module, criteriaRows, sortByField, sortByOrder } = this.state;
        const reachedCriteriaLimit = criteriaRows.length >= MAX_CRITERIA_ROWS;
        const hasIncompleteCriteria = criteriaRows.some((criteria) => !this.isCriteriaComplete(criteria));
        const hasAtLeastOneCompleteCriteria = criteriaRows.some((criteria) => this.isCriteriaComplete(criteria));
        const hasSortSelection = !!sortByField && !!sortByOrder;
        const disableAddButton = reachedCriteriaLimit || hasIncompleteCriteria;
        const addButtonTooltip = hasIncompleteCriteria
            ? 'Select value then add more condition'
            : 'Maximum 5 conditions allowed';
        const disableSave = !reportName || !module || hasIncompleteCriteria || !hasAtLeastOneCompleteCriteria || !hasSortSelection;
        const saveDisabledMessage = !reportName
            ? 'Enter a report name to continue.'
            : !module
                ? 'Select a module to continue.'
                : !hasSortSelection
                    ? 'Kindly fill all the required fields'
                    : hasIncompleteCriteria
                        ? 'Complete or remove the current filter.'
                        : !hasAtLeastOneCompleteCriteria
                            ? 'At least one filter should be selected.'
                            : '';

        const uniqueSortConditions = this.state.sortCondition;
        return (
            <Modal
                show={show}
                onHide={this.handleClose}
                // centered
                className="create-report-modal"
                dialogClassName="modal-90w"
                size='lg'
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <h5>Create Report</h5>
                        <p>Create reports with selected data and filters.</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h6 className='header-title'>Report Information</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label>Report Name <span className="red-star">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter report name"
                                    value={reportName}
                                    onChange={(e) => this.handleChange('reportName', e.target.value)}
                                />
                            </Form.Group>

                        </div>
                        <div className="col-md-6">
                            <Form.Group className="mb-3">
                                <Form.Label>
                                    Select Category <span className="red-star">*</span>{' '}
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="select-category-tooltip">
                                                Category defines the type of data your report will be based on.
                                            </Tooltip>
                                        }
                                    >
                                        <span
                                            className="d-inline-flex align-items-center"
                                            role="img"
                                            aria-label="Category help"
                                            style={{ cursor: 'help', verticalAlign: 'text-bottom' }}
                                        >
                                            <PiInfoDuotone className="text-muted" size={14} />
                                        </span>
                                    </OverlayTrigger>
                                </Form.Label>
                                <Form.Control
                                    as="select"
                                    value={module}
                                    onChange={(e) => this.handleChange('module', e.target.value)}
                                >
                                    <option value="">Select Category</option>
                                    {this.state.modules.map((m) => (
                                        <option key={m} value={m}>{hypenateToNormal(m)}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                        </div>
                    </div>

                    <h6 className='header-title'>Set Criteria</h6>


                    <div className='filter-criteria-list'>
                        <ul className='filter-criteria-list-items'>
                            <li
                                className={`filter-criteria-list-item-column ${this.state.criteriaType === 'column' ? 'active' : ''}`}
                                onClick={() => this.handleCriteria('column')}
                            >
                                Column
                            </li>
                            <li
                                className={`filter-criteria-list-item-column ${this.state.criteriaType === 'filter' ? 'active' : ''}`}
                                onClick={() => this.handleCriteria('filter')}
                            >
                                Filter
                            </li>
                        </ul>
                    </div>


                    {this.state.criteriaType !== 'column' ? (
                        <>
                            <div className="noteSection mt-0">
                                <p className="d-flex align-items-center gap-1"> <PiInfoDuotone className="text-muted" size={14} /> Apply conditions to show only specific data in the report. </p>
                            </div>
                            {criteriaRows.map((criteria, index) => {
                                const rule = this.getRuleForAttribute(criteria.attribute);
                                const allowedOperators = rule ? (rule.allowedOperators || []) : [];

                                return (
                                    <div className={`row ${index > 0 ? 'mt-3' : ''}`} key={`criteria-row-${index}`}>
                                        <div className={`col-md-12 ${index > 0 ? 'mb-2' : ''}`}>
                                            {index > 0 && <small className="fw-bold">{criteria.joiner}</small>}
                                        </div>

                                        <div className="col-md-11">
                                            <div className="row">

                                                <div className="col-md-4">
                                                    {index === 0 && <Form.Label>Attribute <span className="red-star">*</span></Form.Label>}
                                                    <Form.Control
                                                        as="select"
                                                        value={criteria.attribute}
                                                        onChange={(e) => this.handleAttributeChange(index, e.target.value)}
                                                    >
                                                        <option value="">Select Attribute</option>
                                                        {this.state.rules
                                                            .filter((r) => {
                                                                if (r.attribute === criteria.attribute) return true;
                                                                return !criteriaRows.some(
                                                                    (row, i) => i !== index && row.attribute === r.attribute
                                                                );
                                                            })
                                                            .map((r) => (
                                                                <option key={r.attribute} value={r.attribute}>
                                                                    {formatAttributeLabel(r.attribute)}
                                                                </option>
                                                            ))}
                                                    </Form.Control>
                                                </div>

                                                <div className="col-md-4">
                                                    {index === 0 && <Form.Label>Operator <span className="red-star">*</span></Form.Label>}
                                                    <Form.Control
                                                        as="select"
                                                        value={criteria.operator}
                                                        disabled={!criteria.attribute}
                                                        onChange={(e) =>
                                                            this.handleCriteriaChange(index, 'operator', e.target.value)
                                                        }
                                                    >
                                                        <option value="">Select operator</option>
                                                        {allowedOperators.map((op) => (
                                                            <option key={op} value={op}>
                                                                {OPERATOR_LABELS[op] || op}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                </div>

                                                <div
                                                    className="col-md-4"
                                                    style={rule?.rangeType === 'date' ? { padding: 0 } : {}}
                                                >
                                                    {index === 0 && <Form.Label>Value <span className="red-star">*</span></Form.Label>}
                                                    {this.renderValueInput(criteria, index, rule)}
                                                </div>

                                            </div>
                                        </div>

                                        <div className="col-md-1 d-flex align-items-end justify-content-center pb-2">
                                            {index > 0 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    onClick={() => this.handleRemoveCriteria(index)}
                                                    style={{ color: '#dc3545' }}
                                                >
                                                    <FaTrashAlt size={16} />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Add Button */}
                            <div className="d-flex gap-2 mt-3">
                                {disableAddButton ? (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="add-condition-tooltip">{addButtonTooltip}</Tooltip>}
                                    >
                                        <span className="d-inline-block">
                                            <Button
                                                variant="primary"
                                                className="xs-btn"
                                                type="button"
                                                disabled
                                                style={{ pointerEvents: 'none' }}
                                            >
                                                <PiPlus /> AND
                                            </Button>
                                        </span>
                                    </OverlayTrigger>
                                ) : (
                                    <Button
                                        variant="primary"
                                        className="xs-btn"
                                        type="button"
                                        onClick={this.handleAddCriteria}
                                        style={{ fontSize: '12px' }}
                                    >
                                        <PiPlus /> AND
                                    </Button>
                                )}
                            </div>

                            {/* Sort Section */}
                            <div className="row mt-3">
                                <Form.Group className="mb-3 col-md-4">
                                    <Form.Label>Sort By <span className="red-star">*</span></Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={
                                            this.state.sortByField
                                                ? `${this.state.sortByField}:${this.state.sortByOrder}`
                                                : ''
                                        }
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (!val) {
                                                this.setState({ sortByField: '', sortByOrder: '' });
                                            } else {
                                                const [field, order] = val.split(':');
                                                this.setState({ sortByField: field, sortByOrder: order });
                                            }
                                        }}
                                        disabled={this.state.sortCondition.length === 0}
                                    >
                                        <option value="">Sort By</option>
                                        {buildSortOptions(
                                            uniqueSortConditions,
                                            this.state.sortingOrder.length > 0
                                                ? this.state.sortingOrder
                                                : ['asc', 'desc']
                                        ).map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </div>
                        </>
                    ) : (
                        <div className="drag-and-drop-container">
                            <div className="noteSection mt-0">
                                <p className="d-flex align-items-center gap-1"> <PiInfoDuotone className="text-muted" size={14} /> Select the data fields you want to display in the report table. </p>
                            </div>
                            {this.state.columnFields.map((col) => (
                                <div
                                    key={col.id}
                                    className="drag-and-drop-item"
                                    draggable
                                    onDragStart={() => this.handleColumnDragStart(col.id)}
                                    onDragOver={this.handleColumnDragOver}
                                    onDrop={() => this.handleColumnDrop(col.id)}
                                >
                                    <div className='drag-and-drop-item-content'>
                                        <BiGridVertical />
                                        <Form.Check
                                            type="checkbox"
                                            id={`column-${col.id}`}
                                            label={col.label}
                                            checked={col.checked}
                                            onChange={() => this.handleColumnCheckToggle(col.id)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}



                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleClose} type="submit">
                        Cancel
                    </Button>
                    {editMode ? (
                        disableSave ? (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="update-disabled-tooltip">
                                        {saveDisabledMessage || 'At least one column and one filter should be selected.'}
                                    </Tooltip>
                                }
                            >
                                <span className="d-inline-block">
                                    <Button
                                        variant="success"
                                        onClick={this.handleUpdateReport}
                                        type="submit"
                                        disabled
                                        style={{ pointerEvents: 'none' }}
                                    >
                                        Update
                                    </Button>
                                </span>
                            </OverlayTrigger>
                        ) : (
                            <Button variant="success" onClick={this.handleUpdateReport} type="submit">
                                Update
                            </Button>
                        )
                    ) : (
                        disableSave ? (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="save-disabled-tooltip">
                                        {saveDisabledMessage || 'At least one column and one filter should be selected.'}
                                    </Tooltip>
                                }
                            >
                                <span className="d-inline-block">
                                    <Button
                                        variant="success"
                                        onClick={this.handleCreateReport}
                                        type="submit"
                                        disabled
                                        style={{ pointerEvents: 'none' }}
                                    >
                                        Save
                                    </Button>
                                </span>
                            </OverlayTrigger>
                        ) : (
                            <Button variant="success" onClick={this.handleCreateReport} type="submit">
                                Save
                            </Button>
                        )
                    )}

                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(CreateReportModal);
